const { searchParams } = new URL(location.href);
/**
 * 通过url params debug <br/>
 * 强制使用腾讯p2p的示例: `https://live.bilibili.com/blanc/55?wpdP2PType=8`
 */
export var DebugUrlParamKeys;
(function (DebugUrlParamKeys) {
    /**
     * 控制 p2pType，取值参考
     * {@link P2PType | P2PType}
     */
    DebugUrlParamKeys["P2PType"] = "wpdP2PType";
    /**
     * 在清晰度中开放 hevc 选项，取值 0,1
     */
    DebugUrlParamKeys["SupportHEVC"] = "wpdSupportHEVC";
    /**
     * 将日志内容打印到控制台，取值 0,1
     */
    DebugUrlParamKeys["Log2Console"] = "wpdLog2Console";
    /**
     * 将广播消息打印到控制台，取值 0,1
     */
    DebugUrlParamKeys["SocketMsg2Console"] = "wpdSocketMsg2Console";
    /**
     * 弹幕渲染类型，取值 css3、canvas、offlineCanvas
     */
    DebugUrlParamKeys["DMRenderType"] = "wpdDMRenderType";
})(DebugUrlParamKeys || (DebugUrlParamKeys = {}));
const p2pRaw = searchParams.get(DebugUrlParamKeys.P2PType);
const log2ConsoleRaw = searchParams.get(DebugUrlParamKeys.Log2Console);
const sptHEVCRaw = searchParams.get(DebugUrlParamKeys.SupportHEVC);
const sktMsgRaw = searchParams.get(DebugUrlParamKeys.SocketMsg2Console);
// 值为 boolean 类型的配置，默认（null）取 false，有值则非 0 取 true
export default {
    P2PType: p2pRaw == null ? null : Number(p2pRaw),
    Log2Console: log2ConsoleRaw == null ? false : log2ConsoleRaw !== '0',
    SupportHEVC: sptHEVCRaw == null ? false : sptHEVCRaw !== '0',
    SocketMsg2Console: sktMsgRaw == null ? false : sktMsgRaw !== '0',
    DMRenderType: searchParams.get(DebugUrlParamKeys.DMRenderType)
};
//# sourceMappingURL=player-debug.js.map